<template>
    <transition name="modal-fade">
        <div class="modal modal-mask" style="display: block">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    
                    <template v-if="defineExistingPathID != 0">
                        <template v-if="existingPath">
                            <div class="modal-header">
                                <h5 class="modal-title">Existing Path</h5>
                                <button type="button" class="close" v-on:click="$emit('close')">&times;</button>
                            </div>
                            <div class="modal-body">
                                <div class="prompt">This path is already defined. You have reached the end of the <b>{{name}}</b> path. Click Restart to define a new path.</div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" @click="$emit('close')">{{ lang['button.cancel'] }}</button>
                                <button type="button" class="btn btn-primary btn-gradient" @click="startOver">Restart</button>
                            </div>
                        </template>
                        <template v-else>
                            <div class="modal-header">
                                <h5 class="modal-title">Complete Path</h5>
                                <button type="button" class="close" v-on:click="$emit('close')">&times;</button>
                            </div>
                            <div class="modal-body">
                                <div class="prompt">Would you like to save this path as <b>{{name}}</b>?</div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" @click="$emit('close')">{{ lang['button.cancel'] }}</button>
                                <button type="button" class="btn btn-primary btn-gradient" @click="savePath">{{ lang['button.save'] }}</button>
                            </div>
                        </template>
                    </template>
                    
                    <template v-else>
                        <template v-if="!existingPath">
                            <div class="modal-header">
                                <h5 class="modal-title">New Path</h5>
                                <button type="button" class="close" v-on:click="$emit('close')">&times;</button>
                            </div>
                            <div class="modal-body">
                                <div v-if="nameError" class="alert alert-danger" role="alert">
                                    Please enter a name for this path
                                </div>
                                <div class="prompt">This path doesn't have a name. Give it a name to make it reusable and easy to find when creating scenarios.</div>
                                <div class="form-group">
                                    <label for="modelName">Name</label>
                                    <input type="text" name="modelName" class="form-control" id="modelName" required="true" maxlength="50" v-model="name" @keyup="nameError = false">
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" @click="$emit('close')">{{ lang['button.cancel'] }}</button>
                                <button type="button" class="btn btn-primary btn-gradient" @click="savePath">{{ lang['button.save'] }}</button>
                            </div>
                        </template>
                        <template v-else-if="!editingProblem">
                            <div class="modal-header">
                                <h5 class="modal-title">Existing Path</h5>
                                <button type="button" class="close" v-on:click="$emit('close')">&times;</button>
                            </div>
                            <div class="modal-body">
                                <div class="prompt">This path is already defined. You have reached the end of the <b>{{name}}</b> path. Click Restart to define a new path.</div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" @click="$emit('close')">{{ lang['button.cancel'] }}</button>
                                <button type="button" class="btn btn-primary btn-gradient" @click="startOver">Restart</button>
                            </div>
                        </template>
                        <template v-else-if="editingProblem">
                            <div class="modal-header">
                                <h5 class="modal-title">Scenario Path Completed</h5>
                                <button type="button" class="close" v-on:click="$emit('close')">&times;</button>
                            </div>
                            <div class="modal-body">
                                <div class="prompt">You have reached the end of the <b>{{name}}</b> path. Click OK to add this path to the scenario or cancel to start over.</div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" @click="startOver">{{ lang['button.cancel'] }}</button>
                                <button type="button" class="btn btn-primary btn-gradient" @click="addPathToScenario">{{ lang['button.ok'] }}</button>
                            </div>
                        </template>
                    </template>

                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['pathData'],
    data() {
        return {
            name: '',
            nameError: false,
            id: 0,
            defineExistingPathID: 0,
            editingProblem: false,
            existingPath: false,
            lang: lang,
        }
    },

    mounted() {
        this.editingProblem = editingProblem;
        if(this.editingProblem){
            this.defineExistingPathID = 0;
        }
        else {
            this.defineExistingPathID = this.pathData.defineExistingPathID;
        }

        if(this.defineExistingPathID == 0){
            if(!this.pathData.id) {
                $.get('/paths/' + this.pathData.model_id + '/get-new-path-id', (res)=> {
                    this.id = +res;
                })
                .catch((error) => {
                    bus.$emit('popupError', error);
                });
            } else {
                this.existingPath = true;
                this.name = this.pathData.name;
                this.id = this.pathData.id;
            }
        }
        else {
            if(this.pathData.id) {
                this.existingPath = true;
                this.name = this.pathData.name;
                this.id = this.pathData.id;
            } else {
                this.name = dbProfiles[this.defineExistingPathID].name;
                this.id = this.defineExistingPathID;
            }
        }
    },

    methods: {
        addPathToScenario() {
            bus.$emit('addPath', this.id, this.name);
            definePath = false;
            this.closeModal();
        },

        closeModal() {
            this.name = '';
            this.$emit('close');
        },

        startOver() {
            redrawPath([])
            this.closeModal();
        },

        savePath() {
            this.nameError = !this.name && !this.name.trim().length > 0
            if(!this.nameError) {
                var pathObj = {
                    id: this.id,
                    name: this.name,
                    decision_id: this.pathData.decisionId,
                    path: this.pathData.path,
                    model_id: this.pathData.model_id,
                    invalid: this.pathData.invalid,
                }
                $.post('/paths/' + this.pathData.model_id + '/save', pathObj,
                res => {
                    if(res != 'error') {
                        this.addPathToScenario();
                        dbProfiles[pathObj.id] = pathObj;
                    }
                })
                .catch((error) => {
                    bus.$emit('popupError', error);
                });
            }
        },
    }
}
</script>
